// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import AWS from 'aws-sdk';

Vue.config.productionTip = false;

const poolId = 'us-west-2:3fd5f8dc-1678-447b-8546-a9a41d5c7c11';
const region = 'us-west-2';

localStorage.setItem('poolid',poolId);
localStorage.setItem('region', region);

function initCredentials() {
  const credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: poolId,
  }, { region });
  return credentials;
}

const credentials = initCredentials();

credentials.getPromise().then(function () {
  localStorage.setItem('credentials', JSON.stringify(credentials,null,2));
  localStorage.setItem('cognitoid', credentials.identityId);
  console.log('identityId is: ' + credentials.identityId);
  const awsConfig = new AWS.Config({region, credentials});
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App :awsconfig=awsconfig />',
    components: {
      App,
    },
    data: {
      awsconfig: awsConfig,
    }
  });
}, function (err) {
  console.error('err: ' + err);
});








// WEBPACK FOOTER //
// ./src/main.js